
let final_list={
    "data":[
        {
            "headTitle1": "Dashboard",
            "headTitle2": "Get Regular Updates",
            "type": "headtitle"
        },
        {
            "path": "/dashboard/main",
            "title": "Dashboard",
            "icon": "disc",
            "type": "link"
        },
        // {
        //     "path": "/dashboard/shelter",
        //     "title": "Shelter Dashboard",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "headTitle1": "Disasters",
        //     "headTitle2": "Get Occupancy Summary",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/disasters/occupancy-summary",
        //     "title": "Occupancy Summary",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // Subscribers - QuickCV
        // {
        //     "headTitle1": "Subscription",
        //     "headTitle2": "Manage Your Subscribers",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/subscription/user/list",
        //     "title": "User",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/subscription/payment-initiated/list",
        //     "title": "Payment Initiated",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/subscription/activated/list",
        //     "title": "Paid & Activated",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/subscription/expiring/list",
        //     "title": "Expiring Soon",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/subscription/expired/list",
        //     "title": "Expired",
        //     "icon": "disc",
        //     "type": "link"
        // },

        {
            "headTitle1": "Content",
            "headTitle2": "Manage Your Contents",
            "type": "headtitle"
        },
        {
            "path": "/content/home/banner",
            "title": "Home Banner",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/content/expertise",
            "title": "Expertise",
            "icon": "disc",
            "type": "link"
        },
        {
            "title": "Research",
            "type": "sub",
            "icon": "disc",
            "active": false,
            "children": [
                {
                    "path": "/content/research/category",
                    "title": "Category",
                    "icon": "disc",
                    "type": "link"
                },
                {
                    "path": "/content/research/list",
                    "title": "Research",
                    "icon": "disc",
                    "type": "link"
                }
            ]
        },
        {
            "title": "Publication",
            "type": "sub",
            "icon": "disc",
            "active": false,
            "children": [
                {
                    "path": "/content/publication/category",
                    "title": "Category",
                    "icon": "disc",
                    "type": "link"
                },
                {
                    "path": "/content/publication/list",
                    "title": "Publication",
                    "icon": "disc",
                    "type": "link"
                }
            ]
        },
        {
            "path": "/content/co-production-lab",
            "title": "CoProduction Lab",
            "icon": "disc",
            "type": "link"
        },
        {
            "title": "Advocacy",
            "type": "sub",
            "icon": "disc",
            "active": false,
            "children": [
                {
                    "path": "/content/advocacy/category",
                    "title": "Category",
                    "icon": "disc",
                    "type": "link"
                },
                {
                    "path": "/content/advocacy/list",
                    "title": "Advocacy",
                    "icon": "disc",
                    "type": "link"
                }
            ]
        },
        {
            "path": "/content/news",
            "title": "News",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "About",
            "headTitle2": "Manage Your Information",
            "type": "headtitle"
        },
        {
            "path": "/about/about",
            "title": "About",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/about/partner",
            "title": "Partner",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/about/involvement",
            "title": "Involvement",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/about/team",
            "title": "Team",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Career",
            "headTitle2": "Manage Your Job & Career Section",
            "type": "headtitle"
        },
        {
            "path": "/career/job/list",
            "title": "Job",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/career/job/applicant",
            "title": "Applicant",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Contact",
            "headTitle2": "Manage Your Contact & Subscribers",
            "type": "headtitle"
        },
        {
            "path": "/contact/message",
            "title": "Message",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/contact/subscriber",
            "title": "Subscriber",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Setting",
            "headTitle2": "Manage Your Website Setting",
            "type": "headtitle"
        },
        {
            "path": "/setting/notice",
            "title": "Notice",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/setting/site-setting",
            "title": "Setting",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/setting/policy",
            "title": "Policy",
            "icon": "disc",
            "type": "link"
        },

        // {
        //     "path": "/resources/emergency-contact/list",
        //     "title": "Emergency Contacts",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "headTitle1": "Volunteer",
        //     "headTitle2": "Register & Manage Your Volunteer",
        //     "type": "headtitle"
        // },
       
        // {
        //     "path": "/volunteer/register",
        //     "title": "Register Volunteer",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/volunteer/list",
        //     "title": "Volunteer",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/slider",
        //     "title": "Slider",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
        // {
        //     "path": "/admin/counter",
        //     "title": "Counter",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/team",
        //     "title": "Team Member",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/partner",
        //     "title": "Partners",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/application",
        //     "title": "Application",
        //     "icon": "disc",
        //     "type": "link"
        // },
 
        //Resources
        // {
        //     "headTitle1": "Resources",
        //     "headTitle2": "Manage Resources",
        //     "type": "headtitle"
        // },
        // {
        //     "title": "Press Release",
        //     "type": "sub",
        //     "icon": "disc",
        //     "active": false,
        //     "children": [
        //         {
        //             "path": "/admin/press-release",
        //             "title": "Press Release",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/quotes",
        //             "title": "Quotes",
        //             "icon": "disc",
        //             "type": "link"
        //         },

        //     ]
        // },
        // {
        //     "path": "/admin/news",
        //     "title": "News",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/law-policy",
        //     "title": "Law & Policy",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/audio-visuals",
        //     "title": "Audio Visuals",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/info-graphics",
        //     "title": "Info Graphics",
        //     "icon": "disc",
        //     "type": "link"
        // },
       




     
        //Get Involved
        // {
        //     "headTitle1": "Get Involved",
        //     "headTitle2": "Manage Involvements",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/jobs",
        //     "title": "Employment",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/cfp",
        //     "title": "Call for Proposal",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/fellowship",
        //     "title": "Fellowship",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/qna",
        //     "title": "FAQ",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/contact",
        //     "title": "Contact",
        //     "icon": "disc",
        //     "type": "link"
        // },

        

        

        // {
        //     "headTitle1": "Campaigns & Gallery",
        //     "headTitle2": "Manage Campaigns and Gallery",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/gallery",
        //     "title": "Gallery",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/campaign",
        //     "title": "Campaigns",
        //     "icon": "disc",
        //     "type": "link"
        // },
    


       


        // {
        //     "title": "Base Details",
        //     "type": "sub",
        //     "icon": "disc",
        //     "active": false,
        //     "children": [
        //         {
        //             "path": "/admin/base-detail/campaign",
        //             "title": "Campaign",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/law_n_policy",
        //             "title": "Law & Policy",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/news",
        //             "title": "News",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/press_release",
        //             "title": "Press Release",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/mission_vision",
        //             "title": "Mission & Vision",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/accountibility",
        //             "title": "Accountibility",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/governance",
        //             "title": "Governance",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/about_article19_asia",
        //             "title": "About Article 19 Asia",
        //             "icon": "disc",
        //             "type": "link"
        //         },
               
               
              
        //     ]
        // },

    

 

      


        // {
        //     "headTitle1": "About Us",
        //     "headTitle2": "Manage about us",
        //     "type": "headtitle"
        // },
       
        // {
        //     "path": "/admin/base-detail/who_we_are",
        //     "title": "Who We Are",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/what-we-do",
        //     "title": "What We Do",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/where-we-work",
        //     "title": "Where We Work",
        //     "icon": "disc",
        //     "type": "link"
        // },


        

        // {
        //     "headTitle1": "Settings & More",
        //     "headTitle2": "Manage settings & more",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/site-setting",
        //     "title": "Site Settings",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/content",
        //     "title": "Content",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
       
        // {
        //     "path": "/admin/subscribers",
        //     "title": "Subscribers",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/annual-reports",
        //     "title": "Annual Reports",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
    ]
}






export default final_list
